import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { CheckboxOptionModel } from '../../Forms/models/checkbox-option.model';

export class CheckboxesFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    options: CheckboxOptionModel[];
    binary?: boolean;
    headingId: string;
    appearCondition?: (x: any) => boolean;
    displayMessageCondition?: (x: any) => boolean;
    message?: string;
    hideCheckBox?: (x: any) => string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        options: CheckboxOptionModel[],
        binary?: boolean,
        headingId?: string,
        appearCondition?: (x: any) => boolean,
        displayMessageCondition?: (x: any) => boolean,
        message?: string,
        hideCheckBox?: (x: any) => string,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.options = options;
        this.binary = !!binary;
        this.headingId = headingId;
        this.appearCondition = appearCondition;
        this.displayMessageCondition = displayMessageCondition;
        this.message = message;
        this.hideCheckBox = hideCheckBox;
    }
}
